import { Controller, useForm, UseFormRegister } from 'react-hook-form';
import { useRef } from 'react';

import { CustomInputContainer, ErrorMessage, LabelContainer } from '../CustomInput/styleGuide';
import { CustomTooltip } from '../../atoms';
import { useAppSelector } from '../../../hooks/hooksRedux';
import { RootState } from '../../../store';
import { defaultColors } from '../../../styles/style-guide';
import { NumericFormat } from 'react-number-format';
import styled from 'styled-components';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  error?: string;
  placeholder?: string;
  tooltip?: string;
  leftTooltip?: string;
  control: any;
}

const StyledNumericFormat = styled(NumericFormat)<{
  $hasError?: boolean;
  $errorColor?: string;
  $borderColor?: string;
  $focusColor?: string;
}>`
  height: 2.5rem;
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid ${({ $hasError, $borderColor, $errorColor }) => ($hasError ? $errorColor : $borderColor)};
  padding: 0 1rem;
  font-size: 0.875rem;
  outline: none;
  background-color: ${defaultColors.white};
  color: ${defaultColors.secondary};
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  &:focus {
    border-color: ${({ $focusColor }) => $focusColor};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }
`;
const CustomInputNumberFormat = ({ id, label, error, placeholder, control, tooltip, leftTooltip, ...rest }: Props) => {
  const colors = useAppSelector((state: RootState) => state.styleGuide.data.colors);
  const primaryColor = colors.primary || defaultColors.primary;
  const colorError = '#ef4444';

  return (
    <>
      <CustomInputContainer>
        <div className="flex">
          <LabelContainer $color={error ? colorError : primaryColor}>
            {leftTooltip && <CustomTooltip content={leftTooltip} />}
            {label}
          </LabelContainer>
          {tooltip && <CustomTooltip content={tooltip} />}
        </div>
        <Controller
          name={id}
          control={control}
          render={({ field }) => {
            const display = field.value === 0 ? '' : field.value;
            return(
              <StyledNumericFormat
                value={display}    
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}                    
                allowNegative={false}
                $hasError={!!error}
                $borderColor={primaryColor}
                $focusColor={primaryColor}
                $errorColor="#ef4444"
                placeholder={placeholder}
                onValueChange={(values) => {
                  field.onChange(values.floatValue || 0);
                }}
                type="text"
              />
            )
          }

          }
        />

        {error && <ErrorMessage>{error}</ErrorMessage>}
      </CustomInputContainer>
    </>
  );
};

export { CustomInputNumberFormat };
